function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
import axios from 'axios';
import AxiosUtils from '../../utilities/axios-utils';
import ConfigurationManager from '../configuration-manager';
import SessionStorageManager from '../session-storage-manager';
import { SSMKeys } from '../const';

/**
 * @memberOf module:wdh-feature-b2b
 */
var ApiClientPromotion = /*#__PURE__*/function () {
  function ApiClientPromotion(token) {
    _classCallCheck(this, ApiClientPromotion);
    this.token = token;
  }
  return _createClass(ApiClientPromotion, [{
    key: "initErrorHandling",
    value: function initErrorHandling(callback) {
      this.errorHandlingCallback = callback;
    }

    /**
    * Get the Promotion List.
    */
  }, {
    key: "getPromotionList",
    value: function getPromotionList() {
      var _this = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('api/shop/promotion/promotion-for-cart', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Get all the Promotion List.
     */
  }, {
    key: "getAllPromotionList",
    value: function getAllPromotionList() {
      var _this2 = this;
      var clearCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return new Promise(function (resolve, reject) {
        if (clearCache || !SessionStorageManager.hasData(SSMKeys.allPromos)) {
          axios.get('api/shop/promotion/', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this2.token)).then(function (response) {
            SessionStorageManager.setData(SSMKeys.allPromos, response.data, 'eod');
            resolve(response.data);
          }).catch(function (err) {
            reject(err);
            _this2.errorHandlingCallback(err.response.data);
          });
        } else {
          resolve(SessionStorageManager.getData(SSMKeys.allPromos).data);
        }
      });
    }

    /**
     * Adds free item to the order
     * @param freeItem
     * @returns {Promise<unknown>}
     */
  }, {
    key: "addFreeItem",
    value: function addFreeItem(freeItem) {
      var _this3 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/shop/promotion/addFreeItem', freeItem, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this3.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this3.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * adds or updates promotion to order
     *
     * @param promoCode
     * @returns {Promise<unknown>}
     */
  }, {
    key: "addOrUpdatePromotion",
    value: function addOrUpdatePromotion(promoCode) {
      var _this4 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/shop/promotion', promoCode, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this4.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this4.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * removes a promotion from the order
     *
     * @returns {Promise<unknown>}
     */
  }, {
    key: "removePromotion",
    value: function removePromotion() {
      var _this5 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.delete('/api/shop/promotion', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this5.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this5.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * checks eligibility for free shipping.
     *
     * @returns {Promise<unknown>}
     */
  }, {
    key: "checkFreeShipping",
    value: function checkFreeShipping() {
      var _this6 = this;
      var clearCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return new Promise(function (resolve, reject) {
        if (clearCache || !SessionStorageManager.hasData(SSMKeys.freeShipping)) {
          axios.get('/api/shop/promotion/freeshipping-available', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this6.token)).then(function (response) {
            SessionStorageManager.setData(SSMKeys.freeShipping, response.data, 'eod');
            resolve(response.data);
          }).catch(function (err) {
            reject(err);
            // this.errorHandlingCallback(err.response.data);
          });
        } else {
          resolve(SessionStorageManager.getData(SSMKeys.freeShipping).data);
        }
      });
    }
  }]);
}();
export default ApiClientPromotion;